import { prepareRequest } from './request'

export const searchEvents = ({ body, query, signal = null }) => {
  const request = prepareRequest({
    url: 'sportsbook/search',
    method: 'POST',
    query,
    signal
  })

  return request(body)
}

export const findCategories = ({ body, query, signal = null }) => {
  const request = prepareRequest({
    method: 'POST',
    url: 'sportsbook/categories',
    query,
    signal
  })

  return request(body)
}

// API wrapper for fetching tournaments
export const findTournaments = ({ body, query, signal = null }) => {
  const request = prepareRequest({
    method: 'POST',
    url: 'sportsbook/tournaments',
    query,
    signal
  })

  return request(body)
}

// API wrapper for fetching events
export const findEvents = ({ body, query, signal = null }) => {
  const request = prepareRequest({
    method: 'POST',
    url: 'sportsbook/events:search',
    query,
    signal
  })

  return request(body)
}

export const findEventsByTournaments = ({ body, query, signal = null }) => {
  const request = prepareRequest({
    method: 'POST',
    url: 'sportsbook/events-by-tounaments',
    query,
    signal
  })

  return request(body)
}

export const findEvent = (eventId, query, signal = null) => {
  const request = prepareRequest({
    method: 'GET',
    url: `sportsbook/event/${eventId}`,
    query,
    signal
  })

  return request()
}

// API wrapper for fetching sports
export const findSports = ({ body, query, signal = null }) => {
  const request = prepareRequest({
    method: 'POST',
    url: 'sportsbook/sports',
    query,
    signal
  })

  return request(body)
}

export const getSportsbookSettings = (signal = null) => {
  const request = prepareRequest({
    method: 'GET',
    url: 'sportsbook/settings',
    token: null,
    signal
  })

  return request()
}

export const getSgmOdds = ({ data, signal = null }) => {
  const request = prepareRequest({
    method: 'POST',
    url: '/sportsbook/sgm/outcome',
    signal
  })

  return request(data)
}

export const getSgmOutcomeById = ({ outcomeId, signal = null }) => {
  const request = prepareRequest({
    method: 'GET',
    url: '/sportsbook/sgm/outcome',
    query: {
      id: outcomeId
    },
    signal
  })

  return request()
}
